import React from 'react';
import { TNavBar } from '../../../types/THeaderConfig';

const HeaderNavBarContext = React.createContext<TNavBar>({} as TNavBar);

export default HeaderNavBarContext;
